export default __webpack_public_path__ + "static/media/photo--lg--daniel-2.6f2fb665.jpg";